import React from "react";
import { Pick5 } from "./Pick5";
import { BackButton } from "../NavButton";

export const InfiniteBeta = ({ active, getSlideNumber, updateActiveSlide }) => {
  return (
    <div id="infinite-beta" className={`${active ? "active " : ""}item`}>
      <div
        className="fill"
        id="infinite-beta-poster-no-video"
        style={{ backgroundImage: "url(/images/infinite_beta.jpg)" }}
      >
        <div
          id="infinite-beta-holder"
          className="container white-text"
          style={{ padding: "8% 8% 2%" }}
        >
          <h2 className="helvetica-nueue">Infinite Beta</h2>
          <br />
          <br />
          <p className="helvetica-light">
            Keep doing what you're doing, you'll get what you got.
          </p>
          <br />
          <p>We'll help you slaughter your sacred cows.</p>
          <br />
          <p className="helvetica-light">
            Thanks to "movement's most brilliant beta" Elizabeth Streb. Her
            willingness to question everything including gravity.
          </p>
          <br />
          <BackButton onClick={() => updateActiveSlide(getSlideNumber(Pick5))} />
        </div>
      </div>
    </div>
  );
};
InfiniteBeta.slideName = "InfiniteBeta";
InfiniteBeta.pathname = "/infinite-beta";
